
import type { Klass, LexicalNode } from "lexical";

import { CodeHighlightNode, CodeNode } from "@lexical/code";
import { HashtagNode } from "@lexical/hashtag";
import { AutoLinkNode, LinkNode } from "@lexical/link";
import { ListItemNode, ListNode } from "@lexical/list";
import { MarkNode } from "@lexical/mark";
import { OverflowNode } from "@lexical/overflow";
import { HorizontalRuleNode } from "@lexical/react/LexicalHorizontalRuleNode";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { TableCellNode, TableNode, TableRowNode } from "@lexical/table";

import { EmojiNode } from "./EmojiNode";
import { ExtendedParagraphNode } from "./ExtendedParagraphNode";
import { ExtendedTextNode } from "./ExtendedTextNode";
import { ImageNode } from "./ImageNode";
import { KeywordNode } from "./KeywordNode";
import { VimeoNode } from "./VimeoNode";
import { YouTubeNode } from "./YouTubeNode";

const PlaygroundNodes: Array<Klass<LexicalNode>> = [
    HeadingNode,
    ListNode,
    CodeNode,
    TableNode,
    TableCellNode,
    TableRowNode,
    HashtagNode,
    CodeHighlightNode,
    AutoLinkNode,
    LinkNode,
    OverflowNode,
    ImageNode,
    EmojiNode,
    KeywordNode,
    HorizontalRuleNode,
    YouTubeNode,
    VimeoNode,
    MarkNode,
    ExtendedTextNode,
    QuoteNode,
    ExtendedParagraphNode,
    ListItemNode
    // ExtendedListItemNode
];

export default PlaygroundNodes;
